import { DropdownItem } from '@bugbug/core/components/Dropdown';
import Icon from '@bugbug/core/components/Icon';
import { useTranslation } from 'react-i18next';

import * as S from './GroupActions.styled';

interface GroupActionsProps {
  onOpen: () => void;
  onClose: () => void;
  onDuplicateClick: () => void;
  onRenameClick: () => void;
  onDeleteClick: () => void;
  readOnly: boolean;
}

export const GroupActionsMenu = ({
  onClose,
  onOpen,
  onDuplicateClick,
  onRenameClick,
  onDeleteClick,
  readOnly,
}: GroupActionsProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'groupActions.groupMenu' });

  return (
    <S.Dropdown
      variant="icon"
      anchor="bottom-end"
      iconName="more"
      onOpen={onOpen}
      onClose={onClose}
      disabled={readOnly}
    >
      <DropdownItem onClick={onDuplicateClick}>
        <Icon name="clone" /> {t('single.duplicate', 'Duplicate')}
      </DropdownItem>
      <DropdownItem onClick={onRenameClick}>
        <Icon name="edit" /> {t('single.rename', 'Rename')}
      </DropdownItem>
      <DropdownItem onClick={onDeleteClick}>
        <Icon name="delete" /> {t('single.delete', 'Delete')}
      </DropdownItem>
    </S.Dropdown>
  );
};
